import React, { useState, useEffect } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import SectionForm from './SectionForm';
import HistoryTimeline from './HistoryTimeline';

const SECTIONS = [
  { key: 'acuity', title: 'Visual Acuity' },
  { key: 'refraction', title: 'Refraction' },
  { key: 'iop', title: 'IOP' },
  { key: 'slitlamp', title: 'Slit Lamp' },
  { key: 'fundus', title: 'Fundus / Retina' },
  { key: 'vf', title: 'Visual Field' },
  { key: 'keratometry', title: 'Keratometry / Topography / Pachymetry / Biometry' },
  { key: 'gonioscopy', title: 'Gonioscopy' },
];

function PatientView({ patientId }) {
  const [recordedBy, setRecordedBy] = useState('');
  const [activeSection, setActiveSection] = useState(() => {
    // Get section from URL hash or default to first section
    const hash = window.location.hash.replace('#', '');
    return hash && SECTIONS.find(s => s.key === hash) ? hash : SECTIONS[0].key;
  });

  useEffect(() => {
    // Read hash from URL on mount and when hash changes
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash && SECTIONS.find(s => s.key === hash)) {
        setActiveSection(hash);
      }
    };
    
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  useEffect(() => {
    // Update URL hash when section changes (but don't trigger reload)
    if (window.location.hash.replace('#', '') !== activeSection) {
      window.history.replaceState(null, '', `#${activeSection}`);
    }
  }, [activeSection]);

  const handleTabChange = (value) => {
    setActiveSection(value);
    window.location.hash = value;
  };

  return (
    <div className="container mx-auto max-w-7xl p-4">
      <div className="bg-gradient-to-r from-[#2c5aa0] to-[#1a3a73] text-white p-4 rounded-lg mb-4">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          👁️ Ophthalmology EMR
        </h1>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-semibold mb-2">Recorded By:</label>
        <input
          type="text"
          value={recordedBy}
          onChange={(e) => setRecordedBy(e.target.value)}
          placeholder="Enter name"
          className="w-64 px-3 py-2 border border-gray-300 rounded-md"
        />
      </div>

      <Tabs value={activeSection} onValueChange={handleTabChange} className="w-full">
        <TabsList className="flex-wrap mb-4">
          {SECTIONS.map((section) => (
            <TabsTrigger key={section.key} value={section.key}>
              {section.title}
            </TabsTrigger>
          ))}
        </TabsList>

        {SECTIONS.map((section) => (
          <TabsContent key={section.key} value={section.key}>
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h2 className="text-xl font-bold mb-4 text-[#2c5aa0]">{section.title}</h2>
              <SectionForm
                section={section.key}
                patientId={patientId}
                recordedBy={recordedBy}
              />
              <HistoryTimeline
                section={section.key}
                patientId={patientId}
              />
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}

export default PatientView;

